import { APIConfig } from "@/lib/api";
import { ApiError } from "@/lib/api/api-error";
import { request as __request } from "@/lib/api/request";
import { z } from "zod";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export class CsrfService {
  static async getCsrfToken() {
    try {
      // Make a simple request to the CSRF endpoint
      // The primary purpose is likely to get the Set-Cookie header
      await __request(
        APIConfig,
        {
          method: "GET",
          url: "/api/v1/csrf/",
          // credentials: "include", // APIConfig should handle this
        },
        z.any(),
      );
      // Optionally return true/false based on success, or void
      return true;
    } catch (error) {
      // Use generic error logging
      if (error instanceof ApiError) {
        console.error(
          `[getCsrfToken] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[getCsrfToken] Unexpected error:", error);
      }
      return false;
    }
  }
}
